export enum PortalAvailable {
  //  Module HousingAssociation
  InsuranceAgreements = 'styreforsikringsavtaler',
  InsuranceCases = 'styreforsikringssaker',
  Sublease = 'bruksoverlating_styreportal',
  OurCompany = 'vaartselskap',
  Tenants = 'leietakere',
  CompanyInformation = 'styreselskapsinformasjon',
  DigitalKeys = 'digitalenokler',
  BoardReports = 'styrerapporter',
  PrivacyStatement = 'personvernerklaering',
  BoardAndCommittees = 'styrerOgKomiteerOversiktStyreportal',
  Booking = 'styrebooking',
  // Brukt til å vise vårt selskap
  Owners = 'eiere',

  // Module Economy
  EconomicOverview = 'styreokonominokkeltall',
  InvoiceApproval = 'styreokonomifaktura',
  OperatingCost = 'driftskostnader',
  Budget = 'styrebudsjettliste',
  Compensation = 'utbetalinger',
  Loan = 'styrelaan',
  OrderEntry = 'ordreregistrering',
  Reimbursement = 'utlegg',
  Reports = 'styreokonomirapporter',
  Timesheets = 'godkjenningavtimelister',
  Results = 'resultat',

  // Module Communication
  Email = 'styrekommunikasjoninnboks',
  Sms = 'styrekommunikasjonsms',
  BulletinBoard = 'styreoppslagstavle',
  PortalUsers = 'saksbehandlerportalbrukere',
  Contacts = 'styrekontakter',
  // SMS = 'doesnotexist (yet)'
  CommunicationSettings = 'styrekommunikasjoninnstillinger',
  Messages = 'styrekommunikasjonmeldinger',
  MeldingerBate = 'meldinger_bate',
  Subjects = 'styrekommunikasjontemaer',

  // Module Boardwork
  Boardmeetings = 'moeter',
  Agreements = 'avtaler',
  AnnualMeeting = 'generalforsamling',
  AnnualMeeting2 = 'generalforsamling2',
  AttendanceList = 'styrefremmoeteliste',
  Documents = 'styredokumenter',
  BoardDocuments = 'styretsdokumenter',
  ProgressPlan = 'fremdriftsplan',
  Signings = 'signeringer',
  YearWheel = 'aarshjulstyrerom',
  Tasks = 'styrearbeidoppgaver',
  NewOwners = 'styreoppgavernyeeiere',
  Really = 'avtalerfrareally',

  // Module HousingCooperative
  Trainingcourses = 'styrebblkurs',
  Publications = 'styreinfofrabblpubliseringer',
  ProductCatalog = 'tjenestekatalogportal',

  // Sustainability
  Sustainability = 'baerekraft',
  CarbonFootprint = 'karbonregnskap',

  // Auditor
  AuditorReports = 'revisorokonomirapporter',
  AuditorInvoiceArchive = 'revisorlevfakturaforesporsel',
  AuditorLoan = 'revisorlaan',
  AuditorBoardAndCommittees = 'revisorstyreogkomiteeroversikt',

  // Janitor
  JanitorTimeManagment = 'vaktmestertimeforing',
  JanitorBoardAndCommittees = 'vaktmesterstyreogkomiteeroversikt',

  // Bevar
  BevarHms = 'styrearbeidbevar',

  // Vedlikehold (RegioX RX)
  VedlikeholdRx = 'styrearbeidvedlikeholdRx',

  // DiscountDeals
  Rabattavtaler = 'rabattavtaler',

  // Målere
  Maalere = 'styremaalere',
}
